(() => {
  const STORAGE_KEY = 'strengthlab_cookie_consent_v1';
  const root = document.querySelector('[data-sl-cookie-banner]');
  if (!root) return;

  if (new URLSearchParams(window.location.search).has('preview_theme_id')) {
    root.classList.add('sl-cookie--preview');
  }

  const panel = root.querySelector('[data-sl-cookie-panel]');
  const acceptButton = root.querySelector('[data-sl-cookie-accept]');
  const necessaryButton = root.querySelector('[data-sl-cookie-necessary]');
  const customizeButton = root.querySelector('[data-sl-cookie-customize]');
  const saveButton = root.querySelector('[data-sl-cookie-save]');
  const inputs = Array.from(root.querySelectorAll('[data-sl-cookie-input]'));

  function readStoredConsent() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null'); }
    catch (error) { return null; }
  }

  function storeConsent(consent) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...consent, savedAt: new Date().toISOString() }));
    } catch (error) {}
  }

  function loadCustomerPrivacy(callback) {
    if (window.Shopify?.customerPrivacy) {
      callback(window.Shopify.customerPrivacy);
      return;
    }

    if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        callback(error ? null : window.Shopify?.customerPrivacy || null);
      });
      return;
    }

    callback(null);
  }

  function applyConsent(consent) {
    storeConsent(consent);

    loadCustomerPrivacy((privacy) => {
      if (privacy?.setTrackingConsent) {
        privacy.setTrackingConsent({
          analytics: Boolean(consent.analytics),
          marketing: Boolean(consent.marketing),
          preferences: Boolean(consent.preferences),
        }, hideBanner);
      } else {
        hideBanner();
      }
    });
  }

  function hideBanner() {
    root.hidden = true;
  }

  function showBanner() {
    root.hidden = false;
  }

  function selectedConsent() {
    return inputs.reduce((consent, input) => {
      consent[input.dataset.slCookieInput] = input.checked;
      return consent;
    }, {});
  }

  function openPreferences() {
    panel.hidden = false;
    saveButton.hidden = false;
    acceptButton.hidden = true;
    customizeButton.hidden = true;
    saveButton.focus({ preventScroll: true });
  }

  function shouldShowWithApi(privacy) {
    const stored = readStoredConsent();
    if (stored) return false;

    try {
      const current = privacy?.currentVisitorConsent?.();
      if (current && ['analytics', 'marketing', 'preferences'].some((key) => current[key] === 'yes' || current[key] === 'no')) {
        return false;
      }
    } catch (error) {}

    return true;
  }

  acceptButton?.addEventListener('click', () => applyConsent({ analytics: true, marketing: true, preferences: true }));
  necessaryButton?.addEventListener('click', () => applyConsent({ analytics: false, marketing: false, preferences: false }));
  customizeButton?.addEventListener('click', openPreferences);
  saveButton?.addEventListener('click', () => applyConsent(selectedConsent()));

  window.StrengthLabCookies = {
    open() {
      panel.hidden = false;
      saveButton.hidden = false;
      acceptButton.hidden = true;
      customizeButton.hidden = true;
      showBanner();
    },
    reset() {
      try { localStorage.removeItem(STORAGE_KEY); } catch (error) {}
      showBanner();
    },
  };

  loadCustomerPrivacy((privacy) => {
    if (shouldShowWithApi(privacy)) showBanner();
  });
})();
